import DashboardScaffold from "ui/common/components/layout/DashboardScaffold/DashboardScaffold";
import AdminsTable from "../containers/AdminsTable/AdminsTable";

export default function AdminsPage() {
    return (
        <DashboardScaffold>
            <div />
            <AdminsTable />
        </DashboardScaffold>
    );
}
